// SaldoLanchoneteAssociados.js - VERSÃO CORRIGIDA
import React, { useState, useContext, useEffect } from 'react';
import { FaMoneyBillWave, FaTimes, FaCreditCard, FaLock } from 'react-icons/fa';
import { FaCashRegister } from 'react-icons/fa';
import Layout from '../components/Layout';
import AppContext from '../api/AppContext';

const API_BASE = 'https://app.olympicbarbacena.com.br/api';

const SaldoLanchoneteAssociado = () => {
  const { user, token } = useContext(AppContext);
  const userId = user?.id || user?._id;
  
  const [modalAberto, setModalAberto] = useState(false);
  const [valorSaldo, setValorSaldo] = useState('');
  const [etapaPagamento, setEtapaPagamento] = useState('valor');
  const [dadosPagamento, setDadosPagamento] = useState({
    numeroCartao: '',
    nomeTitular: '',
    validade: '',
    cvv: '',
    cpfTitular: '',
    salvarCartao: false
  });
  const [saldoAtual, setSaldoAtual] = useState(0);
  const [mensagem, setMensagem] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [carregandoSaldo, setCarregandoSaldo] = useState(false);

  const isMobile = typeof window !== 'undefined' ? window.innerWidth < 768 : false;

  const getStyles = () => ({
    container: {
      margin: '0 auto',
      fontFamily: '"Montserrat", sans-serif',
      backgroundColor: '#f8f9fa',
      minHeight: '100vh',
      color: '#212529'
    },
    headerWrap: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: isMobile ? '16px' : '24px',
      maxWidth: 1200,
      margin: '0 auto',
      width: '100%',
      boxSizing: 'border-box'
    },
    balanceCard: {
      background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
      borderRadius: '20px',
      padding: isMobile ? '20px' : '32px',
      boxShadow: '0 8px 32px rgba(9, 68, 140, 0.1)',
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      justifyContent: 'space-between',
      alignItems: isMobile ? 'stretch' : 'center',
      gap: isMobile ? '20px' : '40px',
      width: '100%',
      border: '1px solid #e2e8f0',
      position: 'relative',
      overflow: 'hidden'
    },
    balanceInfo: {
      flex: 1,
      textAlign: isMobile ? 'center' : 'left'
    },
    balanceText: {
      fontSize: isMobile ? '14px' : '16px',
      color: '#64748b',
      marginBottom: '8px',
      fontWeight: '500',
      textTransform: 'uppercase',
      letterSpacing: '0.5px'
    },
    balanceValue: {
      fontSize: isMobile ? '32px' : '48px',
      fontWeight: '700',
      color: '#09448C',
      textShadow: '0 2px 4px rgba(9, 68, 140, 0.1)',
      lineHeight: '1.1'
    },
    loadingContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '12px'
    },
    loadingText: {
      fontSize: isMobile ? '14px' : '16px',
      color: '#64748b',
      fontWeight: '500'
    },
    loadingSpinner: {
      width: '32px',
      height: '32px',
      border: '3px solid #e2e8f0',
      borderTop: '3px solid #09448C',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    },
    actionsContainer: {
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      gap: '12px',
      alignItems: 'center'
    },
    addButton: {
      backgroundColor: 'rgb(76, 175, 80)',
      color: '#fff',
      border: 'none',
      borderRadius: '12px',
      padding: isMobile ? '14px 20px' : '16px 28px',
      cursor: 'pointer',
      fontWeight: '600',
      fontSize: isMobile ? '14px' : '16px',
      transition: 'all 0.3s ease',
      boxShadow: '0 4px 12px rgba(9, 68, 140, 0.3)',
      minWidth: isMobile ? '100%' : '160px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    refreshButton: {
      backgroundColor: '#244a6fff',
      color: '#fff',
      border: 'none',
      borderRadius: '12px',
      padding: isMobile ? '12px 16px' : '14px 20px',
      cursor: 'pointer',
      fontWeight: '600',
      fontSize: isMobile ? '13px' : '14px',
      transition: 'all 0.3s ease',
      boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
      minWidth: isMobile ? '100%' : '140px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    refreshButtonDisabled: {
      backgroundColor: '#94a3b8',
      color: '#fff',
      border: 'none',
      borderRadius: '12px',
      padding: isMobile ? '12px 16px' : '14px 20px',
      cursor: 'not-allowed',
      fontWeight: '600',
      fontSize: isMobile ? '13px' : '14px',
      opacity: 0.7,
      minWidth: isMobile ? '100%' : '140px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    buttonContent: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      justifyContent: 'center'
    },
    refreshIcon: {
      fontSize: '16px'
    },
    plusIcon: {
      fontSize: '18px',
      fontWeight: 'bold'
    },
    spinnerSmall: {
      width: '16px',
      height: '16px',
      border: '2px solid transparent',
      borderTop: '2px solid #ffffff',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    },
    // Adicione esta animação CSS no seu arquivo de estilos global ou no componente
    '@global': {
      '@keyframes spin': {
        '0%': { transform: 'rotate(0deg)' },
        '100%': { transform: 'rotate(360deg)' }
      }
    },
    refreshButtonDisabled: {
      backgroundColor: '#6c757d',
      color: '#fff',
      border: 'none',
      borderRadius: 10,
      padding: isMobile ? '8px 12px' : '10px 16px',
      cursor: 'not-allowed',
      fontWeight: 700,
      fontSize: isMobile ? 12 : 14,
      opacity: 0.6
    },

    /* Modal */
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.45)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999,
      padding: isMobile ? '12px' : '24px'
    },
    modalContent: {
      backgroundColor: '#fff',
      borderRadius: 12,
      width: '100%',
      maxWidth: 520,
      maxHeight: '90vh',
      overflowY: 'auto',
      boxShadow: '0 12px 40px rgba(2, 6, 23, 0.12)',
      position: 'relative'
    },
    modalHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: isMobile ? '14px' : '20px',
      borderBottom: '1px solid #eef2f6'
    },
    modalTitle: {
      fontSize: isMobile ? 18 : 20,
      fontWeight: 700,
      color: '#09448C',
      display: 'flex',
      alignItems: 'center',
      gap: 10
    },
    closeButton: {
      background: 'transparent',
      border: 'none',
      fontSize: 20,
      cursor: 'pointer',
      color: '#6c757d'
    },
    modalBody: {
      padding: isMobile ? '14px' : '20px'
    },
    inputLabel: {
      display: 'block',
      fontSize: 13,
      marginBottom: 8,
      color: '#495057',
      fontWeight: 600
    },
    textInput: {
      width: '100%',
      padding: isMobile ? '12px 14px' : '14px 16px',
      borderRadius: 8,
      border: '1px solid #e9ecef',
      fontSize: isMobile ? 15 : 16,
      boxSizing: 'border-box'
    },
    twoCols: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 12
    },
    modalFooter: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: 12,
      padding: isMobile ? '12px' : '16px',
      borderTop: '1px solid #eef2f6',
      alignItems: 'center'
    },
    cancelBtn: {
      backgroundColor: '#6c757d',
      color: '#fff',
      border: 'none',
      borderRadius: 8,
      padding: '10px 16px',
      cursor: 'pointer',
      fontWeight: 700
    },
    primaryBtn: {
      backgroundColor: '#09448C',
      color: '#fff',
      border: 'none',
      borderRadius: 8,
      padding: '10px 16px',
      cursor: 'pointer',
      fontWeight: 700
    },
    successText: {
      color: '#155724',
      backgroundColor: '#e7f3e7',
      padding: '10px',
      borderRadius: 8,
      fontWeight: 600
    },
    errorText: {
      color: '#721c24',
      backgroundColor: '#f8d7da',
      padding: '10px',
      borderRadius: 8,
      fontWeight: 600
    },
    debugPanel: {
      textAlign: 'center',
      fontSize: '12px',
      color: '#666',
      marginTop: '10px',
      padding: '10px',
      backgroundColor: '#f8f9fa',
      borderRadius: '8px',
      maxWidth: 1000,
      margin: '10px auto'
    },
    debugButton: {
      padding: '5px 10px',
      fontSize: '10px',
      marginTop: '5px',
      backgroundColor: '#6c757d',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer'
    }
  });

  const styles = getStyles();

  // Formatadores
  const formatValorDisplay = (valor) => {
    if (!valor && valor !== 0) return '0,00';
    return Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
  };

  const formatarValor = (valor) => {
    const apenasNumeros = valor.replace(/\D/g, '');
    if (apenasNumeros === '') return '';
    const valorNumerico = parseInt(apenasNumeros) / 100;
    return valorNumerico.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const formatarNumeroCartao = (valor) =>
    valor.replace(/\D/g, '').replace(/(\d{4})(?=\d)/g, '$1 ').substring(0, 19);

  const formatarValidade = (valor) => valor.replace(/\D/g, '').replace(/(\d{2})(?=\d)/, '$1/').substring(0, 5);

  const formatarCPF = (valor) =>
    valor.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4').substring(0, 14);

  // FUNÇÃO PARA BUSCAR SALDO - CORRIGIDA
  const buscarSaldoAtual = async () => {
    try {
      //console.log('buscarSaldoAtual')
      setCarregandoSaldo(true);

      if (!userId) {
        console.error('❌ userId não disponível');
        setCarregandoSaldo(false);
        return;
      }

      // ENVIAR USERID COMO QUERY PARAMETER
      const response = await fetch(`${API_BASE}/minha-conta/saldo?userId=${userId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      //console.log('📥 Status da resposta /saldo:', response.status);

      if (response.ok) {
        const data = await response.json();
        //console.log('💰 Saldo recebido da API:', data);
        setSaldoAtual(data.saldo || 0);
      } else {
        console.error('❌ Erro ao buscar saldo:', response.status);
        // Fallback para saldo do contexto
        if (user?.saldo !== undefined) {
          //console.log('🔄 Usando saldo do contexto:', user.saldo);
          setSaldoAtual(user.saldo);
        }
      }
    } catch (error) {
      console.error('❌ Erro ao buscar saldo:', error);
      // Fallback para saldo do contexto
      if (user?.saldo !== undefined) {
        //console.log('🔄 Usando saldo do contexto (fallback):', user.saldo);
        setSaldoAtual(user.saldo);
      }
    } finally {
      setCarregandoSaldo(false);
    }
  };

  // BUSCAR SALDO QUANDO O COMPONENTE É MONTADO
  useEffect(() => {
    //console.log('🚀 Componente montado, userId:', userId);
    if (userId) {
      buscarSaldoAtual();
    }
  }, [userId]);

  // BUSCAR SALDO QUANDO A PÁGINA GANHA FOCO
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden && userId) {
        //console.log('🔄 Página visível, atualizando saldo...');
        buscarSaldoAtual();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [userId]);

  // ATUALIZAR SALDO QUANDO O CONTEXTO MUDAR
  useEffect(() => {
    if (user?.saldo !== undefined && user.saldo !== saldoAtual) {
      //console.log('🔄 Contexto atualizado, atualizando saldo:', user.saldo);
      setSaldoAtual(user.saldo);
    }
  }, [user?.saldo]);

  // Handlers
  const handleValorChange = (e) => {
    const valor = e.target.value;
    const valorFormatado = formatarValor(valor);
    setValorSaldo(valorFormatado);
  };

  const handleDadosPagamentoChange = (campo, valor) => {
    let valorFormatado = valor;
    switch (campo) {
      case 'numeroCartao':
        valorFormatado = formatarNumeroCartao(valor);
        break;
      case 'validade':
        valorFormatado = formatarValidade(valor);
        break;
      case 'cpfTitular':
        valorFormatado = formatarCPF(valor);
        break;
      case 'cvv':
        valorFormatado = valor.replace(/\D/g, '').substring(0, 4);
        break;
      default:
        break;
    }
    setDadosPagamento((prev) => ({ ...prev, [campo]: valorFormatado }));
  };

  const abrirModal = () => {
    setModalAberto(true);
    setEtapaPagamento('valor');
    document.body.style.overflow = 'hidden';
  };

  const fecharModal = () => {
    setModalAberto(false);
    setValorSaldo('');
    setEtapaPagamento('valor');
    setDadosPagamento({
      numeroCartao: '',
      nomeTitular: '',
      validade: '',
      cvv: '',
      cpfTitular: '',
      salvarCartao: false
    });
    setMensagem('');
    setCarregando(false);
    document.body.style.overflow = 'auto';
    
    // Buscar saldo atualizado após fechar o modal (especialmente se foi confirmação)
    if (etapaPagamento === 'confirmacao') {
      //console.log('🔄 Fechando modal de confirmação, atualizando saldo...');
      setTimeout(() => {
        buscarSaldoAtual();
      }, 2000);
    }
  };

  const avancarParaPagamento = () => {
    if (!valorSaldo || parseFloat(valorSaldo.replace(',', '.')) <= 0) {
      alert('Por favor, insira um valor válido.');
      return;
    }
    setEtapaPagamento('pagamento');
  };

  const processarPagamento = async () => {
    try {
      setCarregando(true);
      setMensagem('Processando pagamento...');

      if (!userId) {
        setMensagem('Erro: Usuário não identificado. Faça login novamente.');
        setCarregando(false);
        return;
      }

      const valorNumerico = parseFloat(valorSaldo.replace(/\./g, '').replace(',', '.'));
      if (!valorNumerico || valorNumerico <= 0) {
        setMensagem('Valor inválido');
        setCarregando(false);
        return;
      }

      const payload = {
        userId: userId,
        valor: valorNumerico,
        metodo: 'cartao_credito',
        dadosCartao: {
          numeroCartao: dadosPagamento.numeroCartao.replace(/\s/g, ''),
          nomeTitular: dadosPagamento.nomeTitular,
          validade: dadosPagamento.validade,
          cvv: dadosPagamento.cvv
        }
      };

      //console.log('📤 Payload enviado ao backend:', payload);

      // ROTA QUE FUNCIONA: /minha-conta/recarga
      const res = await fetch(`${API_BASE}/minha-conta/recarga`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      //console.log('📥 Status da resposta /minha-conta/recarga:', res.status);

      if (!res.ok) {
        const errText = await res.text().catch(() => null);
        setMensagem(errText || 'Erro ao comunicar com o servidor');
        setCarregando(false);
        return;
      }

      const data = await res.json();
      //console.log('📥 Resposta do backend:', data);

      if (data.success) {
        setMensagem('✅ Recarga criada com sucesso! Aguarde confirmação do PagBank.');
        setEtapaPagamento('confirmacao');
        
        // AGUARDAR E ATUALIZAR SALDO APÓS CONFIRMAÇÃO
        //console.log('🔄 Recarga criada, aguardando para atualizar saldo...');
        setTimeout(() => {
          //console.log('🔄 Atualizando saldo após recarga...');
          buscarSaldoAtual();
        }, 3000);
      } else {
        setMensagem(data.message || 'Erro no processamento');
      }
    } catch (error) {
      console.error('Erro no fetch de recarga:', error);
      setMensagem('Falha na comunicação com o servidor.');
    } finally {
      setCarregando(false);
    }
  };

  const finalizarTransacao = () => {
    //console.log('✅ Finalizando transação, atualizando saldo...');
    buscarSaldoAtual();
    fecharModal();
  };

  const renderModalConteudo = () => {
    switch (etapaPagamento) {
      case 'valor':
        return (
          <>
            <div style={styles.modalHeader}>
              <div style={styles.modalTitle}><FaMoneyBillWave /> <span>Adicionar saldo</span></div>
              <button style={styles.closeButton} onClick={fecharModal}><FaTimes /></button>
            </div>

            <div style={styles.modalBody}>
              <label style={styles.inputLabel}>Valor a adicionar</label>
              <input
                style={styles.textInput}
                type="text"
                placeholder="R$ 0,00"
                value={valorSaldo ? `R$ ${valorSaldo}` : ''}
                onChange={handleValorChange}
                autoFocus
              />
            </div>

            <div style={styles.modalFooter}>
              <button style={styles.cancelBtn} onClick={fecharModal}>Cancelar</button>
              <button style={styles.primaryBtn} onClick={avancarParaPagamento}>Continuar</button>
            </div>
          </>
        );

      case 'pagamento':
        return (
          <>
            <div style={styles.modalHeader}>
              <div style={styles.modalTitle}><FaCreditCard /> <span>Pagamento</span></div>
              <button style={styles.closeButton} onClick={fecharModal}><FaTimes /></button>
            </div>

            <div style={styles.modalBody}>
              <label style={styles.inputLabel}>Número do cartão</label>
              <input
                style={styles.textInput}
                type="text"
                placeholder="0000 0000 0000 0000"
                value={dadosPagamento.numeroCartao}
                onChange={(e) => handleDadosPagamentoChange('numeroCartao', e.target.value)}
              />

              <label style={{...styles.inputLabel, marginTop: 12}}>Nome do titular</label>
              <input
                style={styles.textInput}
                type="text"
                placeholder="Como está no cartão"
                value={dadosPagamento.nomeTitular}
                onChange={(e) => handleDadosPagamentoChange('nomeTitular', e.target.value)}
              />

              <div style={{...styles.twoCols, marginTop: 12}}>
                <div>
                  <label style={styles.inputLabel}>Validade</label>
                  <input
                    style={styles.textInput}
                    type="text"
                    placeholder="MM/AA"
                    value={dadosPagamento.validade}
                    onChange={(e) => handleDadosPagamentoChange('validade', e.target.value)}
                  />
                </div>
                <div>
                  <label style={styles.inputLabel}>CVV</label>
                  <input
                    style={styles.textInput}
                    type="text"
                    placeholder="000"
                    value={dadosPagamento.cvv}
                    onChange={(e) => handleDadosPagamentoChange('cvv', e.target.value)}
                  />
                </div>
              </div>

              <div style={{ marginTop: 12 }}>
                <label style={styles.inputLabel}>CPF do titular (opcional)</label>
                <input
                  style={styles.textInput}
                  type="text"
                  placeholder="000.000.000-00"
                  value={dadosPagamento.cpfTitular}
                  onChange={(e) => handleDadosPagamentoChange('cpfTitular', e.target.value)}
                />
              </div>

              <div style={{ marginTop: 14, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <input
                    id="salvarCartao"
                    type="checkbox"
                    checked={dadosPagamento.salvarCartao}
                    onChange={(e) => setDadosPagamento(prev => ({ ...prev, salvarCartao: e.target.checked }))}
                  />
                  <label htmlFor="salvarCartao" style={{ fontSize: 13 }}>Salvar cartão para futuras compras</label>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <FaLock style={{ color: '#17a2b8' }} />
                  <small style={{ color: '#6c757d' }}>Transação segura</small>
                </div>
              </div>

              {mensagem && (
                <div style={{ marginTop: 12 }}>
                  <div style={mensagem.startsWith('✅') ? styles.successText : styles.errorText}>
                    {mensagem}
                  </div>
                </div>
              )}

              <div style={{ marginTop: 16, textAlign: 'right' }}>
                <button
                  style={{ ...styles.primaryBtn, opacity: carregando ? 0.8 : 1 }}
                  onClick={processarPagamento}
                  disabled={carregando}
                >
                  {carregando ? 'Processando...' : `Pagar R$ ${valorSaldo}`}
                </button>
              </div>
            </div>
          </>
        );

      case 'confirmacao':
        return (
          <>
            <div style={styles.modalHeader}>
              <div style={styles.modalTitle}><FaMoneyBillWave /> <span>Confirmação</span></div>
              <button style={styles.closeButton} onClick={fecharModal}><FaTimes /></button>
            </div>

            <div style={styles.modalBody}>
              <div style={{ marginBottom: 12 }}>
                <div style={styles.successText}>
                  {mensagem || 'Pagamento em processamento. Você será notificado quando o saldo for atualizado.'}
                </div>
              </div>

              <div style={{ marginTop: 8 }}>
                <p style={{ margin: 0 }}>Saldo atual: <strong>R$ {formatValorDisplay(saldoAtual)}</strong></p>
                <p style={{ margin: '5px 0 0 0', fontSize: '12px', color: '#666' }}>
                  O saldo será atualizado automaticamente em alguns segundos.
                </p>
              </div>
            </div>

            <div style={styles.modalFooter}>
              <button style={styles.primaryBtn} onClick={finalizarTransacao}>Concluir</button>
            </div>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <div style={styles.container}>
      <Layout title="Saldo" icon={FaCashRegister}>
        <div style={styles.headerWrap}>
          <div style={styles.balanceCard}>
            <div style={styles.balanceInfo}>
              <div style={styles.balanceText}>Saldo disponível</div>
              {carregandoSaldo ? (
                <div style={styles.loadingContainer}>
                  <div style={styles.loadingSpinner}></div>
                  <div style={styles.loadingText}>Carregando saldo...</div>
                </div>
              ) : (
                <div style={styles.balanceValue}>R$ {formatValorDisplay(saldoAtual)}</div>
              )}
            </div>
            <div style={styles.actionsContainer}>
              {/* <button 
                style={carregandoSaldo ? styles.refreshButtonDisabled : styles.refreshButton}
                onClick={buscarSaldoAtual}
                disabled={carregandoSaldo}
              >
                {carregandoSaldo ? (
                  <div style={styles.buttonContent}>
                    <div style={styles.spinnerSmall}></div>
                    <span>Atualizando</span>
                  </div>
                ) : (
                  <div style={styles.buttonContent}>
                    <span style={styles.refreshIcon}>🔄</span>
                    <span>Atualizar</span>
                  </div>
                )}
              </button> */}
              <button style={styles.addButton} onClick={abrirModal}>
                <div style={styles.buttonContent}>
                  <span style={styles.plusIcon}>+</span>
                  <span>Adicionar saldo</span>
                </div>
              </button>
            </div>
          </div>
        </div>

        {modalAberto && (
          <div style={styles.modalOverlay} onClick={fecharModal}>
            <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
              {renderModalConteudo()}
            </div>
          </div>
        )}
      </Layout>
    </div>
  );
};

export default SaldoLanchoneteAssociado;